// Utility functions for handling dates without timezone issues

// Convert a date to YYYY-MM-DD format in local timezone
export const formatDateForStorage = (date) => {
  if (!date) return null;
  
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

// Parse a date string ensuring it's treated as local date
export const parseLocalDate = (dateString) => {
  if (!dateString) return null;
  
  // If it's already a Date object, return it
  if (dateString instanceof Date) {
    return dateString;
  }
  
  // If it's an ISO string with time, extract just the date part
  if (dateString.includes('T')) {
    dateString = dateString.split('T')[0];
  }
  
  // Parse as YYYY-MM-DD in local timezone
  const [year, month, day] = dateString.split('-').map(num => parseInt(num, 10));
  return new Date(year, month - 1, day);
};

// Format date for display
export const formatDateForDisplay = (dateString) => {
  if (!dateString) return null;
  
  const date = parseLocalDate(dateString);
  if (!date || isNaN(date.getTime())) return null;
  
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString(undefined, options);
};